import { ProductType } from '@ads/front-core/api'
import { IProductDefinition } from '@ads/front-core/products/IProductDefinition'
import { OUTSTREAM_VIDEO_CPM } from './OUTSTREAM_VIDEO_CPM'
import { OUTSTREAM_VIDEO_VCPM } from './OUTSTREAM_VIDEO_VCPM'
import { UNIVERSAL_CPC } from './UNIVERSAL_CPC'
import { UNIVERSAL_CPM } from './UNIVERSAL_CPM'
import { UNIVERSAL_VCPM } from './UNIVERSAL_VCPM'

export const DEFINITIONS: Record<ProductType, IProductDefinition> = {
  UNIVERSAL_CPC,
  UNIVERSAL_CPM,
  UNIVERSAL_VCPM,
  OUTSTREAM_VIDEO_CPM,
  OUTSTREAM_VIDEO_VCPM,
  MAILING_RETARGETING: null,
  MAILING_PROSPECTING: null,
  RETARGETING: null,
  ROAS: null,
  PROSPECTING: null,
  PROSPECTING_2: null,
  DISPLAY_CPC: null,
  DISPLAY_CPC_NATIVE: null,
  DISPLAY_CPM: null,
  DISPLAY_VCPM: null,
  MAILING_CRM: null,
  MAILING_TRANSACTIONAL: null,
  MAILING_STATIC: null,
  MAILING_STATIC_OTHER: null,
  MAILING_STATIC_CPM: null,
  PUBLISHERS_DISPLAY_VCPM: null,
  PUBLISHERS_DISPLAY_CPM: null,
  PUBLISHERS_DISPLAY_CPC: null,
  PUBLISHERS_FLAT_FEE: null,
  PUBLISHERS_SCREENING: null,
  PUSH: null,
  DISPLAY_CPSC: null,
  FEED_CPSC: null,
  NATIVE_LINK_DIRECT: null,
  NATIVE_SG: null,
  START_AD: null,
  PAUSE_AD: null,
}
